import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCajaStatus } from '../features/caja/cajaSlice';

import { readItems } from '@directus/sdk';
import moment from 'moment';
import { getDirectusClient } from '../lib/directus';

export const useCajaStatus = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userdata.id);

  const checkCajaStatus = async () => {
    try {
      const directus = await getDirectusClient();
      const today = moment().startOf('day');
      const tomorrow = moment().endOf('day');

      const response = await directus.request(
        readItems('cajas', {
          fields: ['id', 'fecha_apertura', 'estado'],
          filter: {
            vendedor: { 
              id: { _eq: user }
            },
            estado: { _eq: 1 },
            fecha_apertura: {
              _between: [today.toISOString(), tomorrow.toISOString()]
            }
          },
          sort: ['-fecha_apertura'],
          limit: 1
        })
      );

      if (response && response.length > 0) {
        dispatch(setCajaStatus({
          cajaId: response[0].id,
          isOpen: true
        }));
      } else {
        dispatch(setCajaStatus({
          cajaId: null,
          isOpen: false
        }));
      }
    } catch (error) {
      console.error('Error checking caja status:', error);
    }
  };

  useEffect(() => {
    if (user) {
      checkCajaStatus();
      // Check every 5 minutes
      const interval = setInterval(checkCajaStatus, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [user]);

  return { checkCajaStatus };
};